import { useMemo } from 'react';

import { DomId } from 'constants/DomId';
import { TABLE_PAGINATION_HEIGHT } from 'constants/sizing';

import { useAppBarHeight } from './useAppBarHeight';

export const useSizes = () => {
  const appBarHeight = useAppBarHeight();

  const applicationHeaderHeight = useMemo(
    () =>
      document.getElementById(DomId.ApplicationHeader)?.clientHeight ||
      appBarHeight,
    [appBarHeight]
  );

  const searchHeaderAreaHeight = useMemo(
    () =>
      document.getElementById(DomId.SearchHeaderArea)?.clientHeight ||
      appBarHeight,
    [appBarHeight]
  );

  const tablePaginationHeight = useMemo(
    () =>
      (document.getElementById(DomId.TablePagination)?.clientHeight ||
        TABLE_PAGINATION_HEIGHT) + 1,
    []
  );

  const combinedHeight = useMemo(
    () =>
      applicationHeaderHeight + searchHeaderAreaHeight + tablePaginationHeight,
    [applicationHeaderHeight, searchHeaderAreaHeight, tablePaginationHeight]
  );

  return {
    applicationHeaderHeight,
    searchHeaderAreaHeight,
    tablePaginationHeight,
    combinedHeight,
  };
};
